import { render, staticRenderFns } from "./PdfReader.vue?vue&type=template&id=287e4f49&scoped=true"
import script from "./PdfReader.vue?vue&type=script&lang=js"
export * from "./PdfReader.vue?vue&type=script&lang=js"
import style0 from "./PdfReader.vue?vue&type=style&index=0&id=287e4f49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e4f49",
  null
  
)

export default component.exports